import { render, staticRenderFns } from "./tracetSabk.vue?vue&type=template&id=56e7e776&scoped=true"
import script from "./tracetSabk.vue?vue&type=script&lang=js"
export * from "./tracetSabk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7e776",
  null
  
)

export default component.exports